import React, { ReactNode } from 'react';
import { AccordionTitle } from '../atoms/Accordion';
import cn from 'classnames';

export interface QuestionProps {
	children: ReactNode;
	panelId: string;
	className?: string;
}

const Question = (props: QuestionProps) => {
	const { children, panelId, className } = props;
	return (
		<AccordionTitle
			panelId={panelId}
			className={cn(
				'text-left text-xl font-semibold tracking-tight lg:text-2xl',
				className,
			)}
		>
			{children}
		</AccordionTitle>
	);
};

export default Question;
